import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';

class Visibility extends PureComponent
{
    static displayName = 'Visibility';

    render()
    {
        const {
            hide, show, children, render: Component, renderProps,
        } = this.props;

        return (
            !hide && show
                ? (
                    <Fragment>
                        {children}
                        {Component ? <Component {...renderProps} /> : null}
                    </Fragment>
                )
                : <Fragment />
        );
    }
}

Visibility.defaultProps = {
    hide: false,
    show: true,
};

Visibility.propTypes = {
    hide: PropTypes.bool,
    show: PropTypes.bool,
    children: PropTypes.node,
    render: PropTypes.elementType,
    renderProps: PropTypes.object,
};

export default Visibility;
